import type { PaymentsTabProps } from '../../types'
import { usePaymentsTab } from '../../hooks/usePaymentsTab'
import tabStyles from '../../styles/companyInfoTab.module.css'
import { PaymentsTabHeader } from './payments/PaymentsTabHeader'
import { PaymentsTabCompanyForm } from './payments/PaymentsTabCompanyForm'
import { PaymentsTabPropertySection } from './payments/PaymentsTabPropertySection'
import { PaymentsTabDialogs } from './payments/PaymentsTabDialogs'

export function PaymentsTab(props: PaymentsTabProps) {
    const vm = usePaymentsTab(props)

    return (
        <div data-testid="company-payments-tab-root" className={tabStyles.tabContent}>
            <PaymentsTabHeader />
            <PaymentsTabCompanyForm {...vm} />
            <PaymentsTabPropertySection {...vm} />
            <PaymentsTabDialogs {...vm} />
        </div>
    )
}
